import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box, TextField, FormHelperText, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import DialogComponent from "components/DialogComponent";
import { useShareFilePermissionMutation } from "store/slices/apis/dmsSlice";
import { useParams } from "react-router-dom";
import { DMS_SHARE } from "./dmsPermissions";
import { useDispatch } from "react-redux";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";

const ShareFile = ({ open, handleClose, fileId, onSuccess }) => {
    const { projectId } = useParams();
    const [shareFile, { isLoading, isSuccess, error }] = useShareFilePermissionMutation();
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: {
            email: "",
            permissionType: "",
        },
        validationSchema: yup.object({
            email: yup.string().required("Email is required"),
            permissionType: yup.string().required("Permission Type is required")
        }),
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                const requestBody = {
                    email: values.email,
                    permissionType: values.permissionType,
                    fileId
                }

                const result = await shareFile(requestBody).unwrap();
                if (result?.status === "Success") {
                    openNotification("File Shared Successfully", "success")
                    onSuccess()
                    handleClose();
                }

            } catch (error) {
                openNotification(error?.data?.message || "File Share Failed")
                console.error("Share file failed:", error);
            }
        },
    });

    const openNotification = (msg, type = "error", duration = 5000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <DialogComponent
            title="Share File"
            open={open}
            handleClose={handleClose}
        >
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{ p: 1 }}>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            type="email"
                            fullWidth
                            name="email"
                            label="Email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                            }
                            sx={{ mt: 1 }}
                        />
                        {formik.touched.email && formik.errors.email && (
                            <FormHelperText error>{formik.errors.email}</FormHelperText>
                        )}
                    </Box>

                    <FormControl>
                        <FormLabel id="radio-buttons-group-label">Permission Type</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="radio-buttons-group-label"
                            name="permissionType"
                            value={formik.values.permissionType}
                            onChange={formik.handleChange}
                        >
                            {/* <FormControlLabel value="2" control={<Radio />} label="View" />
                            <FormControlLabel value="3" control={<Radio />} label="Editor" /> */}
                            {DMS_SHARE.map((item) => <FormControlLabel key={item.id} value={item.value} control={<Radio />} label={item.label} />)}
                        </RadioGroup>
                    </FormControl>
                    {formik.touched.permissionType && formik.errors.permissionType && (
                        <FormHelperText error>{formik.errors.permissionType}</FormHelperText>
                    )}
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1.5,
                        mt: 3,
                        pt: 2,
                        borderTop: "1px solid #F3F4F6",
                    }}
                >
                    {/* <CustomButton
                        label="Cancel"
                        onClick={handleClose}
                        sx={{
                            backgroundColor: "#F9FAFB",
                            color: "#4B5563",
                            border: "1px solid #E5E7EB",
                            "&:hover": { backgroundColor: "#F3F4F6" },
                        }}
                    /> */}
                    <Button onClick={handleClose}
                        sx={{
                            textTransform: "none",
                            color: "#F15744",
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            borderRadius: "25px",
                            fontWeight: 500,
                            px: "20px",
                            py: "15px",
                        }}>
                        Cancel
                    </Button>
                    {/* <CustomButton
                        label={isLoading ? "Renaming..." : "Rename"}
                        type="submit"
                        disabled={isLoading}
                        sx={{ backgroundColor: "#00344C", color: "#fff", px: 4 }}
                    /> */}
                    <Button
                        type="submit"
                        variant="contained"
                        loading={isLoading}
                        sx={{
                            backgroundColor: "#00344C",
                            borderRadius: "25px",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            color: "#FFFFFF",
                            px: "20px",
                            py: "15px",
                        }}
                        disabled={isLoading}
                    >
                        Share
                    </Button>
                </Box>
            </form>
        </DialogComponent>
    );
};

export default ShareFile;
